import { render, staticRenderFns } from "./personageOrder.vue?vue&type=template&id=ec7a68a0&scoped=true&"
import script from "./personageOrder.vue?vue&type=script&lang=js&"
export * from "./personageOrder.vue?vue&type=script&lang=js&"
import style0 from "./personageOrder.vue?vue&type=style&index=0&id=ec7a68a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7a68a0",
  null
  
)

export default component.exports